import React, { useState, useEffect } from "react";

import { ListGroupItem } from "react-bootstrap";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { useTopicCategoryContext } from "../../../contexts/TopicCategoryContext";
import TableItem from "./TableItem";
import CreateButton from "./Table/CreateButton";

export default function Table() {
  const { dispatch, actions, state } = useTopicCategoryContext();

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    actions.moveCategory(
      dispatch,
      state.topicCategories,
      result.source.index,
      result.destination.index
    );
  };

  useEffect(() => {
    actions.loadTopicCategories(dispatch);
  }, []);

  return (
    <div>
      <CreateButton />
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <>
              <ul
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="list-group"
              >
                {state.topicCategories == null && (
                  <ListGroupItem align="center">Please, wait ...</ListGroupItem>
                )}
                {state.topicCategories &&
                  state.topicCategories.map((item, index) => (
                    <TableItem key={item.id} index={index} category={item} />
                  ))}
              </ul>
              {provided.placeholder}
            </>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}
